
export default {
  eosApiUrl: 'https://api.eosnewyork.io',
};
